module.exports = __webpack_public_path__ + "static/media/ic_db_refer.d9c2578a.svg";